import { Injectable } from '@angular/core';

import { ConversationCommands } from '../../../data/message/domain/conversation/conversation_commands';

@Injectable()
export class MessageFacade {
  constructor(private conversationCommands: ConversationCommands) {
    // do nothing
  }

  markPatientConversationsAsRead() {
    return this.conversationCommands.markPatientConversationsAsRead();
  }

  markDietitianConversationsAsRead() {
    return this.conversationCommands.markDietitianConversationsAsRead();
  }
}
